import { Container, ContainerProps } from '@hover/blueprint';
import React from 'react';
import ReadyToStartMobile from './ReadyToStartMobile';
import ReadyToStartDesktop from './ReadyToStartDesktop';

interface Props extends ContainerProps {
  backgroundColor: string;
}

const HoInvitedReadyToStart: React.FC<Props> = ({
  backgroundColor,
  ...restProps
}) => (
  <Container
    maxW="1200px"
    mb={1000}
    mt={700}
    px={{ base: 500, desktop: 0 }}
    borderRadius={400}
    overflow="hidden"
    {...restProps}
  >
    <ReadyToStartDesktop backgroundColor={backgroundColor} />
    <ReadyToStartMobile backgroundColor={backgroundColor} />
  </Container>
);

export default HoInvitedReadyToStart;
